function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.instaIcon{fill:#fb3958}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "instaIcon",
  d: "M510.5,150.2c-1.2-27.2-5.6-45.8-11.9-62c-6.5-17.2-16.5-32.5-29.5-45.3c-12.8-13-28.3-23.1-45.2-29.4 c-16.3-6.3-34.8-10.7-62-11.9C334.5,0.3,325.8,0,256.4,0s-78.1,0.3-105.3,1.5s-45.8,5.6-62,11.9C72,19.9,56.6,29.8,43.8,42.9 c-13,12.8-23.1,28.3-29.4,45.2c-6.3,16.3-10.7,34.8-11.9,62c-1.3,27.4-1.6,36-1.6,105.4s0.3,78.1,1.5,105.3 c1.2,27.2,5.6,45.8,11.9,62c6.5,17.2,16.6,32.5,29.5,45.3c12.8,13,28.3,23.1,45.2,29.4c16.3,6.3,34.8,10.7,62,11.9 c27.2,1.2,35.9,1.5,105.3,1.5s78.1-0.3,105.3-1.5c27.2-1.2,45.8-5.6,62-11.9c34.3-13.3,61.5-40.4,74.8-74.8 c6.3-16.3,10.7-34.8,11.9-62c1.2-27.3,1.5-35.9,1.5-105.3S511.7,177.5,510.5,150.2z M464.5,358.9c-1.1,25-5.3,38.4-8.8,47.4 c-8.6,22.3-26.3,39.9-48.5,48.5c-9,3.5-22.6,7.7-47.4,8.8c-27,1.2-35,1.5-103.2,1.5s-76.4-0.3-103.2-1.5c-25-1.1-38.4-5.3-47.4-8.8 c-11.1-4.1-21.2-10.6-29.3-19.1c-8.5-8.3-15-18.3-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4c-1.2-27-1.5-35-1.5-103.2s0.3-76.4,1.5-103.2 c1.1-25,5.3-38.4,8.8-47.4C61.6,94,68.1,84,76.7,75.8C85,67.3,95,60.8,106,56.7c9-3.5,22.6-7.7,47.4-8.8c27-1.2,35-1.5,103.2-1.5 c68.3,0,76.4,0.3,103.2,1.5c25,1.1,38.4,5.3,47.4,8.8c11.1,4.1,21.2,10.6,29.3,19.1c8.5,8.3,15,18.3,19.1,29.4 c3.5,9,7.7,22.6,8.8,47.4c1.2,27,1.5,35,1.5,103.2S465.7,331.9,464.5,358.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "instaIcon",
  d: "M256.4,124.3c-72.5,0-131.3,58.8-131.3,131.3S184,386.8,256.4,386.8c72.5,0,131.3-58.8,131.3-131.3 S328.9,124.3,256.4,124.3z M256.4,340.7c-47,0-85.2-38.1-85.2-85.2s38.1-85.2,85.2-85.2c47,0,85.2,38.1,85.2,85.2 S303.5,340.7,256.4,340.7z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "instaIcon",
  d: "M423.6,119.1c0,16.9-13.7,30.6-30.6,30.6s-30.6-13.7-30.6-30.6s13.7-30.6,30.6-30.6 C409.8,88.4,423.6,102.2,423.6,119.1z"
});

var SvgInsta = function SvgInsta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 511",
    style: {
      enableBackground: "new 0 0 511 511"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insta.7089cd85.svg";
export { ForwardRef as ReactComponent };